<template>
  <v-col cols="12" class="ma-0 pa-0">
    <v-row v-for="(item, index) in listComment" :key="index" class="px-2 py-2">
      <v-col
        cols="12"
        class="d-flex pa-2 pr-0"
        style="border-radius: 4px"
        :style="{ 'background-color': item.is_unread ? '#e1f5fe' : '#ffffff' }"
      >
        <div>
          <div style="width: 48px; height: 48px; position: relative">
            <v-avatar size="48" color="#E0E0E0">
              <v-img
                :src="item.profile_path ? item.profile_path : defaultImage"
              ></v-img>
            </v-avatar>
            <v-icon
              v-if="replyCommentId == item.id"
              color="#3F51B5"
              class="comment-bounce"
              style="position: absolute; top: -12px; left: -16px"
              >mdi-message-reply-text</v-icon
            >
          </div>
          <div
            v-if="item.reply_comment.length > 0"
            class="d-flex justify-center reply-line-content"
          >
            <div class="reply-line"></div>
          </div>
        </div>

        <div class="ml-2 mr-0" style="width: 100%">
          <div>
            <div class="d-flex align-center">
              <div class="black--text label-name">
                {{ item.fullname }}
              </div>
              <div class="grey--text ml-2 label-date">
                {{ item.created_at | formatDateComment }}
              </div>
              <div v-if="item.is_can_manage" class="mr-0 ml-auto">
                <v-menu
                  bottom
                  left
                  offset-y
                  origin="top right"
                  transition="scale-transition"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn dark icon v-on="on" class="mr-1">
                      <v-icon color="grey darken-2">mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-list tile>
                    <v-list-item-group color="primary">
                      <v-list-item style="min-height: 28px">
                        <v-list-item-title
                          v-if="item.is_can_delete"
                          class="text-center"
                          >{{ $t("delete") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <div class="mt-2 label-comment">
              <span style="white-space: pre-line">{{ item.comment }}</span>
              <!-- {{ item.comment }} -->
            </div>

            <!-- ========== ========== Report Comment File ========== ========== -->
            <div v-if="item.report_files.length > 0" class="mt-2 pr-3">
              <div class="black--text label-attachment">
                {{
                  $t("textAttachmentCount", {
                    count: item.report_files.length,
                  })
                }}
              </div>
              <div
                v-for="(item_file, index_file) in item.report_files"
                :key="index_file"
                class="my-2 d-flex pa-2 align-center attachment-box"
                @click="handleClickPreview(item_file)"
              >
                <v-icon class="mr-2">mdi-file-check-outline</v-icon>
                <div style="word-break: break-all">
                  {{ item_file.name }}
                </div>
                <v-btn
                  class="mr-0 ml-auto"
                  icon
                  @click="handleClickDownload($event, item_file)"
                >
                  <v-icon color="blue">mdi-download-outline</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- ========== ========== Report Comment Schema ========== ========== -->
            <div v-if="item.report_comment_schema_id" class="mt-2 pr-3">
              <div
                class="black--text label-attachment mb-2"
                style="text-decoration: underline"
              >
                {{ $t("textForm") }}
              </div>
              <div
                class="d-flex align-center"
                style="
                  width: 100%;
                  border: 1px solid #9e9e9e;
                  border-radius: 8px;
                  padding: 6px 8px;
                "
              >
                <v-icon class="mr-2">mdi-file-document-edit-outline</v-icon>
                <div class="text-dot-1">
                  {{ item.schema_label }}
                </div>
              </div>
            </div>

            <div
              v-if="isEmployeeComment"
              class="mt-2 ml-1 label-reply d-flex align-center"
              style="width: fit-content; gap: 8px"
              @click="handleClickReplyComment(item)"
            >
              <v-icon small color="#1e88e5" style="transform: scaleX(-1)"
                >mdi-reply</v-icon
              >
              <div>
                {{
                  item.report_comment_schema_id
                    ? $t("textReplyForm")
                    : $t("textReply")
                }}
              </div>
            </div>
          </div>

          <!-- ========== ========== Reply ========== ========== -->
          <div
            v-for="(item_reply, index_reply) in item.reply_comment"
            :key="index_reply"
            class="d-flex pa-2 pr-0 mt-2"
            style="border-radius: 4px"
            :style="{
              'background-color': item_reply.is_unread ? '#e1f5fe' : '#ffffff',
            }"
          >
            <v-avatar size="48" color="#E0E0E0">
              <v-img
                :src="
                  item_reply.profile_path
                    ? item_reply.profile_path
                    : defaultImage
                "
              ></v-img>
            </v-avatar>
            <div class="ml-2" style="width: 100%">
              <div>
                <div class="d-flex align-center">
                  <div class="black--text label-name">
                    {{ item_reply.fullname }}
                  </div>
                  <div class="grey--text ml-2 label-date">
                    {{ item_reply.created_at | formatDateComment }}
                  </div>
                  <div v-if="item_reply.is_can_manage" class="mr-0 ml-auto">
                    <v-menu
                      bottom
                      left
                      offset-y
                      origin="top right"
                      transition="scale-transition"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn dark icon v-on="on" class="mr-1">
                          <v-icon color="grey darken-2"
                            >mdi-dots-horizontal</v-icon
                          >
                        </v-btn>
                      </template>

                      <v-list tile>
                        <v-list-item-group color="primary">
                          <v-list-item style="min-height: 28px">
                            <v-list-item-title
                              v-if="item_reply.is_can_delete"
                              class="text-center"
                              >{{ $t("delete") }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
                <div class="mt-2 label-comment">
                  <span style="white-space: pre-line">{{
                    item_reply.comment
                  }}</span>
                </div>

                <!-- ========== ========== Report Comment Schema ========== ========== -->
                <div
                  v-if="item_reply.schema_detail"
                  class="my-2"
                  style="width: calc(100% - 12px)"
                >
                  <div
                    class="mb-1 black--text"
                    style="font-weight: 500; text-decoration: underline"
                  >
                    {{ $t("textForm") }}
                  </div>
                  <div>
                    <div
                      v-for="(
                        item_schema, index_schema
                      ) in formatMyFlatQuestion(item_reply.schema)"
                      :key="index_schema"
                      class="d-flex mb-1"
                    >
                      <div class="mr-2 black--text" style="max-width: 50%">
                        {{
                          formatMyQuestion(item_schema.name, item_reply.schema)
                        }}
                        :
                      </div>
                      <div>
                        <!-- Image -->
                        <div
                          v-if="
                            checkTypeMyQuestion(
                              item_schema.name,
                              item_reply.schema
                            ) === 'image'
                          "
                          class="d-flex flex-wrap"
                          style="gap: 8px"
                        >
                          <img
                            v-for="(itemImage, i) in formatMyDetail(
                              item_schema.name,
                              item_reply.schema,
                              item_reply.schema_detail
                            )"
                            :key="i"
                            style="
                              width: 100%;
                              max-width: fit-content;
                              max-height: 120px;
                              object-fit: contain;
                              border-radius: 4px;
                            "
                            :src="itemImage.content"
                            @click="handleClickPreviewFormQuestion(itemImage)"
                          />
                        </div>
                        <!-- Text -->
                        <div
                          v-else-if="
                            checkTypeMyQuestion(
                              item_schema.name,
                              item_reply.schema
                            ) === 'text'
                          "
                          style="font-size: 16px; white-space: pre-line"
                        >
                          {{
                            formatMyDetail(
                              item_schema.name,
                              item_reply.schema,
                              item_reply.schema_detail
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ========== ========== Report Comment File ========== ========== -->
                <div
                  v-if="item_reply.report_files.length > 0"
                  class="mt-2 pr-3"
                >
                  <div class="black--text label-attachment">
                    {{
                      $t("textAttachmentCount", {
                        count: item_reply.report_files.length,
                      })
                    }}
                  </div>
                  <div
                    v-for="(item_file, index_file) in item_reply.report_files"
                    :key="index_file"
                    class="my-2 d-flex pa-2 align-center attachment-box"
                    @click="handleClickPreview(item_file)"
                  >
                    <v-icon class="mr-2">mdi-file-check-outline</v-icon>
                    <div style="word-break: break-all">
                      {{ item_file.name }}
                    </div>
                    <v-btn
                      class="mr-0 ml-auto"
                      icon
                      @click="handleClickDownload($event, item_file)"
                    >
                      <v-icon color="blue">mdi-download-outline</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="item.total_reply_comment > item.reply_comment.length"
            class="d-flex align-center mt-2"
            style="width: fit-content"
            @click="handleClickViewMoreReplyComment(index)"
          >
            <v-icon class="mr-1" color="#616161">mdi-chevron-down</v-icon>
            <div class="label-view-more">{{ $t("textViewMoreReply") }}</div>
            <div v-if="item.is_unread_reply" class="ml-2 dot"></div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row
      v-if="totalComment > 0 && totalComment != listComment.length"
      class="mt-4"
    >
      <v-col cols="12" class="py-0 mb-6">
        <div
          class="d-flex align-center"
          style="width: fit-content"
          @click="handleClickViewMoreComment()"
        >
          <v-icon class="mr-1" color="#616161">mdi-chevron-down</v-icon>
          <div class="label-view-more">{{ $t("textViewMoreComment") }}</div>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from "moment";
import Axios from "@/config/customer-service";
import {
  checkTypeQuestion,
  formatDetail,
  formatFlatQuestion,
  formatQuestion,
} from "../../config/general-function";
import {
  firebaseListener,
  firebaseStopListener,
} from "../../config/firebaseMessage";
import { mapState } from "vuex";

export default {
  inject: ["isAppLoading"],
  emits: ["onClickReplyComment", "onClickPreviewFile"],
  props: {
    isEmployeeComment: { default: false },
    reportId: { default: null },
    forCreatedBy: { default: "admin" },
  },
  data() {
    return {
      options: {
        lastCommentId: "",
        itemsPerPage: 10,
      },
      optionsReply: {
        lastCommentId: "",
        itemsPerPage: 10,
      },
      totalComment: 0,
      listComment: [],
      curReplyComment: {},
      replyCommentId: null,

      firebaseTopic: "",
    };
  },
  created() {
    const topic = `report/${this.reportId}/report_comment`;
    this.firebaseTopic = topic;
    firebaseListener(topic, (data) => {
      this.realtimeCheckUpdate(topic, data);
    });
    // ========== ========== ========== ==========
    this.getListReportAdminComment();
  },
  beforeDestroy() {
    if (this.firebaseTopic) {
      firebaseStopListener(this.firebaseTopic);
    }
  },
  methods: {
    // ========== ========== Form ========== ==========
    formatMyFlatQuestion(schema) {
      return formatFlatQuestion(schema);
    },
    formatMyQuestion(question, schema) {
      return formatQuestion(question, schema);
    },
    formatMyDetail(question, schema, schema_detail) {
      return formatDetail(schema_detail[question], question, schema);
    },
    checkTypeMyQuestion(question, schema) {
      return checkTypeQuestion(question, schema);
    },
    handleClickPreviewFormQuestion(param) {
      const detail = {
        url: param.content,
        name: param.name,
      };
      this.$emit("onClickPreviewFile", detail);
    },
    // ========== ========== ========== ==========

    async getListReportAdminComment() {
      try {
        const { lastCommentId, itemsPerPage } = this.options;
        let response = await Axios.get(
          `/report-admin/getListReportAdminComment`,
          {
            params: {
              per_page: itemsPerPage,
              last_comment_id: lastCommentId,
              report_id: this.reportId,
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          let fetchData = dataResponse.data;
          this.totalComment = fetchData.total;
          this.options.lastCommentId = fetchData.last_report_comment_id;
          this.listComment = [...this.listComment, ...fetchData.data];
        }
      } catch (err) {
        console.log("getListReportAdminComment", err);
      }
    },
    async getListReportAdminReplyComment(comment_id) {
      try {
        const { lastCommentId, itemsPerPage } = this.optionsReply;
        let current_post_comment_id = "";
        const current_post_comment = this.curReplyComment[comment_id];
        if (current_post_comment) {
          current_post_comment_id = current_post_comment
            .map((x) => x.id)
            .join(",");
        }
        let response = await Axios.get(
          `/report-admin/getListReportAdminReplyComment`,
          {
            params: {
              per_page: itemsPerPage,
              last_comment_id: lastCommentId,
              report_id: this.reportId,
              comment_id: comment_id,
              current_post_comment_id: current_post_comment_id,
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          let fetchData = dataResponse.data;
          const model = this.listComment.find((x) => x.id == comment_id);
          if (model) {
            model.total_reply_comment = fetchData.total;
            this.optionsReply.lastCommentId = fetchData.last_report_comment_id;
            if (!Array.isArray(model.reply_comment)) {
              model.reply_comment = [];
            }
            // ========== ========== Check Current Post ========== ==========
            const _curReplyComment = this.curReplyComment[comment_id];
            if (_curReplyComment) {
              for (let item of _curReplyComment) {
                model.reply_comment = model.reply_comment.filter(
                  (x) => x.id != item.id
                );
                const _index = fetchData.data.findIndex((x) => x.id > item.id);
                if (_index >= 0) {
                  fetchData.data.splice(_index, 0, item);
                  this.curReplyComment[comment_id] = this.curReplyComment[
                    comment_id
                  ].filter((x) => x.id != item.id);
                } else {
                  fetchData.data.push(item);
                }
              }
            }
            model.reply_comment = [...model.reply_comment, ...fetchData.data];
          }
        }
      } catch (err) {
        console.log("getListReportAdminReplyComment", err);
      }
    },
    async getListReportAdminCommentForRealtime() {
      try {
        const { itemsPerPage } = this.options;
        let response = await Axios.get(
          `/report-admin/getListReportAdminComment`,
          {
            params: {
              per_page: itemsPerPage,
              last_comment_id: null,
              report_id: this.reportId,
            },
          }
        );
        const dataResponse = response?.data;
        if (dataResponse.status == "success") {
          let fetchData = dataResponse.data;
          this.totalComment = fetchData.total;
          if (this.listComment.length > 0 && fetchData.data.length > 0) {
            const first_comment_id = this.listComment[0].id;
            const list = fetchData.data.filter((x) => x.id > first_comment_id);
            this.listComment = [...list, ...this.listComment];
          }
        }
      } catch (err) {
        console.log("getListReportAdminCommentForRealtime", err);
      }
    },
    async realtimeCheckUpdate(topic, data) {
      if (data?.report_id != this.reportId) {
        return;
      }
      if (data?.reply_report_comment_id) {
        let check_employee = true;
        if (data.send_to_employee_id) {
          if (data.send_to_employee_id != this.customer.id) {
            check_employee = false;
          }
        }
        if (check_employee) {
          const model = this.listComment.find(
            (x) => x.id == data.reply_report_comment_id
          );
          if (model) {
            if (model.total_reply_comment > model.reply_comment.length) {
              model.is_unread_reply = true;
            } else if (model.total_reply_comment == 0) {
              model.is_unread_reply = true;
              model.total_reply_comment = 1;
            } else {
              this.getListReportAdminReplyComment(data.reply_report_comment_id);
            }
          }
        }
      } else {
        this.getListReportAdminCommentForRealtime();
      }
    },

    // ========== ========== Post ========== ==========
    async handlePostComment(param) {
      this.totalComment++;
      this.listComment.unshift(param);
    },
    async handlePostReplyComment(param) {
      const comment_id = param.reply_report_comment_id;
      const model = this.listComment.find((x) => x.id == comment_id);
      if (model) {
        model.total_reply_comment++;
        if (!Array.isArray(model.reply_comment)) {
          model.reply_comment = [];
        }
        model.reply_comment.push(param);
        if (!this.curReplyComment[comment_id]) {
          this.curReplyComment[comment_id] = [];
        }
        this.curReplyComment[comment_id].push(param);
        model.is_unread = false;
      }
    },
    // ========== ========== ========== ==========

    handleClickReplyComment(param) {
      this.replyCommentId = param.id;
      this.$emit("onClickReplyComment", param);
    },
    async handleClickViewMoreComment() {
      this.getListReportAdminComment();
    },
    handleClickViewMoreReplyComment(index) {
      const comment = this.listComment[index];
      const comment_id = comment.id;
      this.getListReportAdminReplyComment(comment_id);
    },
    handleClearReplyComment() {
      this.replyCommentId = null;
    },

    // ========== ========== Preview ========== ==========
    handleClickPreview(param) {
      this.$emit("onClickPreviewFile", param);
    },
    async handleClickDownload(event, param) {
      event.stopPropagation();
      this.isAppLoading(true);
      try {
        let filename = param.name;
        let response = await fetch(param.url, {
          cache: "no-cache",
        });
        let blob = await response.blob();
        let url = await URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.crossOrigin = "Anonymous";
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data),
          showConfirmButton: false,
          timer: 3000,
        });
      }
      this.isAppLoading(false);
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },
  filters: {
    formatDateComment: function (value) {
      if (!value) return "-";

      const now = moment();
      const date = moment(value);

      // คำนวณส่วนต่างเป็น "วัน"
      const diffInDays = now.diff(date, "days");

      // เงื่อนไข: ถ้าเก่ากว่า 7 วัน ให้แสดงวันที่เต็ม
      if (diffInDays > 7) {
        return date.format("DD MMM YY");
      }

      // ถ้ายังไม่เกิน 7 วัน ให้แสดงแบบ "4 hours ago", "3 days ago"
      return date.fromNow();
    },
  },
  watch: {},
};
</script>

<style scoped>
::v-deep .v-input__slot {
  max-height: 120px !important;
}

::v-deep .v-text-field__slot {
  overflow-y: auto;
}

.reply-line-content {
  width: 100%;
  height: calc(100% - 72px);
  padding-top: 8px;
}

.reply-line {
  width: 1px;
  height: 100%;
  background-color: #9e9e9e;
}

.label-name {
  font-size: 16px;
  font-weight: 600;
}

.label-date {
  font-size: 16px;
  font-weight: 400;
}

.label-comment {
  color: #000000;
  font-size: 16px;
  word-break: break-word;
}

.label-reply {
  color: #1e88e5;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.label-view-more {
  color: #616161;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.dot {
  background-color: #f44336;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.label-attachment {
  font-size: 16px;
  font-weight: 600;
}

.label-name {
  font-size: 16px;
  font-weight: 600;
}

.attachment-box {
  background-color: #ffffff;
  border: 1px solid #9e9e9e;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.attachment-box:hover {
  background-color: #eeeeee;
}

.comment-bounce {
  animation: comment-bounce 1.5s infinite;
}

@keyframes comment-bounce {
  0% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }

  50% {
    transform: translateY(-4px);
    /* Increased amplitude for a more pronounced bounce */
    animation-timing-function: ease-in;
  }

  100% {
    transform: translateY(0);
    animation-timing-function: ease-out;
  }
}
</style>